'use strict';

export default {
  getHost() {
    return typeof window !== 'undefined' && window.location && window.location.host;
  }
};



// WEBPACK FOOTER //
// ./app-data/location.js